import { render, staticRenderFns } from "./CityDetail.vue?vue&type=template&id=6b208a52&"
import script from "./CityDetail.vue?vue&type=script&lang=js&"
export * from "./CityDetail.vue?vue&type=script&lang=js&"
import style0 from "./CityDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports